import React, { useState, useEffect, useRef } from "react";

const TravelTourismManagementAdmissionRequirements = ({ componentData }) => {
  const [visibleElements, setVisibleElements] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(
            () => setVisibleElements((prev) => ({ ...prev, title: true })),
            100,
          );
          setTimeout(
            () => setVisibleElements((prev) => ({ ...prev, content: true })),
            400,
          );
        }
      },
      { threshold: 0.1 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "ADMISSION REQUIREMENTS";
  const content = componentData?.content || 
    "The applicant should posses at least four (4) passes in non-religious subjects in the Certificate of Secondary Education Examination (CSEE) or should posses the National Vocational Award Level III (Trade Test Grade I) in a relevant field from a recognized institution with any Certificate of Secondary Education Examination (CSEE) OR Equivalent as approved by the ATC Governing Board.";

  return (
    <section
      ref={sectionRef}
      className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 via-white to-gray-100 overflow-hidden"
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-80 h-80 bg-custom-pink/10 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-32 left-20 w-96 h-96 bg-gold/10 rounded-full blur-3xl animate-float-delayed" />
      </div>

      {/* Decorative Pattern */}
      <div className="absolute inset-0 bg-net-pattern opacity-3" />

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Main Title */}
        <div
          className={`text-center mb-2 transform transition-all duration-1000 ${
            visibleElements.title
              ? "translate-y-0 opacity-100"
              : "translate-y-10 opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-custom-pink leading-tight">
            {title}
          </h2>
          <div className="w-32 h-1 bg-gold mx-auto rounded-full mt-4" />
        </div>

        {/* Main Content */}
        <div
          className={`transform transition-all duration-1000 delay-300 ${
            visibleElements.content
              ? "translate-y-0 opacity-100"
              : "translate-y-10 opacity-0"
          }`}
        >
          <div className="bg-white/70 backdrop-blur-sm  p-8 md:p-12 lg:p-16">
            <div className="text-left max-w-7xl mx-auto">
              <p className="text-base md:text-lg lg:text-xl text-black leading-loose tracking-wide mb-8 whitespace-pre-line">
                {content}
              </p>
              <p className="text-base md:text-lg lg:text-xl text-gray-800 leading-loose tracking-wide border-l-4 border-gold pl-5 italic">
                Upon successful completion, students will be awarded a Certificate (1 Year) or Diploma (2 Years) as applicable, recognized by the relevant accreditation authorities in Tanzania.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) translateX(0px);
          }
          33% {
            transform: translateY(-15px) translateX(10px);
          }
          66% {
            transform: translateY(10px) translateX(-10px);
          }
        }

        @keyframes floatDelayed {
          0%,
          100% {
            transform: translateY(0px) translateX(0px);
          }
          33% {
            transform: translateY(20px) translateX(-15px);
          }
          66% {
            transform: translateY(-10px) translateX(15px);
          }
        }

        .animate-float {
          animation: float 10s ease-in-out infinite;
        }

        .animate-float-delayed {
          animation: floatDelayed 12s ease-in-out infinite 3s;
        }
      `}</style>
    </section>
  );
};

export default TravelTourismManagementAdmissionRequirements;
